import { getOsVersion, OS_INFO } from '@ringcentral/rwc-utils/src/client-detection';
import { getBrandName, webClientCommitHash } from '@low/web-client-info';
import getConfig from '@ringcentral/rwc-utils/src/config';
import { generateUid } from '@ringcentral/rwc-utils/src/misc';
import { notifyOnOkRequest } from '@ringcentral/rwc-utils/src/network-ok-requests';
import { joinFlowRequestTracker } from '@ringcentral/rwc-utils/src/join-flow/join-flow-tracking';

export const getUaHeaderPostfix = () => {
    const osVersion = getOsVersion();
    return `(${getBrandName()}; ${OS_INFO}/${osVersion}; rev.${webClientCommitHash})`;
};

export const getPatchedFetch =
    (fetch, { skipRcRequestId = false } = {}) =>
    (resource, init) => {
        const req = new Request(resource, init);
        const xUserAgent = req.headers.get('X-User-Agent');
        req.headers.set('X-User-Agent', xUserAgent + ' ' + getUaHeaderPostfix());
        const { shouldAddExtraHeaders, extraHeaders } = getConfig('PAS');
        if (shouldAddExtraHeaders && extraHeaders) {
            Object.entries(extraHeaders).forEach(([key, value]) => {
                req.headers.set(key, value);
            });
        }

        const HEADER_NAME = 'RCRequestId';
        let rcId = req.headers.get(HEADER_NAME);
        if (!skipRcRequestId && !rcId) {
            rcId = generateUid();
            req.headers.set(HEADER_NAME, rcId);
        }

        const fetchPromise = fetch(req);

        return fetchPromise.then(r => {
            joinFlowRequestTracker.maybeHandleResponse(req.url, {
                ok: r.ok,
                status: r.status,
                rcRequestId: r.headers.get('RCRequestId'),
            });

            notifyOnOkRequest(r);
            return r;
        });
    };

export const getXUserAgentHeader = ({ appName, appVersion }) =>
    appName ? appName + (appVersion ? '/' + appVersion : '') + ' ' : '';

export const addPlatformHeaders = (headers, { appName, appVersion }) => {
    if (!headers) {
        headers = new Headers();
    }

    const xUserAgentHeader = getXUserAgentHeader({ appName, appVersion });

    if (headers.set) {
        headers.set('X-User-Agent', xUserAgentHeader);
    } else {
        headers['X-User-Agent'] = xUserAgentHeader;
    }

    return headers;
};
